import useApi from '../../../api/useApi';
import { CampaignGetDetail } from '../../../api/orgService';
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router';
import { toast } from 'react-toastify';
import CampaignShowcase from '../../sections/CampaignShowcase';
import CampaignCreateForm from '../../forms/CampaignCreateForm';
import CampaignReadPage from '../../pages/CampaignReadPage';

function CampaignAdminRead() {
  const { request: getCampaign, data:campaignData, error:campaignError} = useApi(CampaignGetDetail);
  const [publishedData,setPublushedData]=useState({})
    const location = useLocation()
      useEffect(()=>{
        if(location?.state?.campaignId){
          getCampaign(location?.state?.campaignId)
        }else if(location?.state?.campaignId === null){
          // console.log(location?.pathname.split("/"))
          getCampaign(location?.pathname.split("/")[4])
        }
      },[location])
    
      useEffect(()=>{
        if (campaignData?.status===200) {
          setPublushedData(campaignData?.data);
        }
      },[campaignData])
    
      useEffect(()=>{
          if(campaignError){
              toast.error(`${JSON.stringify(campaignError?.response?.data,null,2)}`,{position: "top-center"});
        }
      },[campaignError])

  return (
    <div>
      <CampaignReadPage campaignData={publishedData} isArticleAdminRead={true}isCampaign={true}/>
    </div>
  )
}

export default CampaignAdminRead